<template>
  <div class="share-page">
    <el-skeleton :loading="loading" animated>
      <div class="scrollable-content">
        <!-- 推荐图片标题栏 -->
        <div class="card-box">
          <!-- 标题行 -->
          <div class="image-header">
            <span class="left">长按保存图片</span>
            <span class="right"></span>
          </div>
          <!-- 九宫格图片 -->
          <div class="image-grid" v-if="images.length">
            <div class="img-item"
                 v-for="(img, idx) in images"
                 :key="idx">
              <img :src="img.imageUrl" loading="lazy" alt="">
            </div>
          </div>
        </div>
        <!-- 文案区域 -->
        <div class="content-box">
          <div class="content-header">
            <h2 class="content-title">{{ shareData.font }}</h2>
          </div>
          <p class="desc">{{ shareText }}</p>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="bottom-action">
        <button class="share-btn"
                :style="{ backgroundColor: shareData.buttonColor }"
                :aria-label="`复制文案并${shareData.buttonText}`"
                @click="onShare">
          {{ shareData.buttonText }}
        </button>
      </div>
    </el-skeleton>
  </div>
</template>

<script>
import UAParser from "ua-parser-js";

// 平台常量定义
const PLATFORMS = {
  MEITUAN: 'mt',
  DAZHONGDIANPING: 'dzdp',
  XIAOHONGSHU: 'xhs'
};

// 平台配置常量
const PLATFORM_CONFIG = {
  [PLATFORMS.MEITUAN]: {
    font: '点评文案预览',
    buttonColor: '#ffc300',
    buttonText: '复制文案并发布'
  },
  [PLATFORMS.DAZHONGDIANPING]: {
    font: '点评文案预览',
    buttonColor: '#ff6633',
    buttonText: '复制文案并发布'
  },
  [PLATFORMS.XIAOHONGSHU]: {
    font: '点评文案预览',
    buttonColor: '#ff2442',
    buttonText: '复制文案并发布'
  }
};

export default {
  name: "SharePage",

  data() {
    return {
      loading: true,
      images: [],
      shareText: "",
      shareData: {},
      url: 'https://script-res-cdn.jxkj1987.cn/',
      deviceInfo: null,
      canDeepLink: true,
      sseBuffer: '',
    };
  },

  created() {
    const routerData = window.history.state;
    if (routerData) {
      this.fetchThemeDetails(routerData);
      this.fetchThemeText(routerData);
    }
    this.checkBrowser();
  },

  methods: {
    fetchThemeDetails(item) {
      const data = {
        shopId: item.shopId,
        qrCodeId: item.qrCodeId,
        themeId: item.id,
      };

      this.$POST('/customer/evaluation/copy/generateImage', data)
          .then(res => this.handleImageResponse(res, item))
          .catch(error => this.handleApiError(error));
    },

    handleImageResponse(res, item) {
      const { imageList = [], shopConfig = {} } = res.data;

      this.images = imageList.map(img => ({
        ...img,
        imageUrl: `${this.url}${img.imageUrl}`
      }));

      const platform = PLATFORM_CONFIG[item.type];
      if (!platform) {
        this.handleApiError(new Error('不支持的平台类型'));
        return;
      }

      this.shareData = {
        ...platform,
        deeplink: this.getDeepLink(item, shopConfig)
      };

      this.loading = false;
    },

    getDeepLink(item, shopConfig = {}) {
      const { mtShopLink, dzShopLink, dzShopConfig } = shopConfig;

      switch (item.type) {
        case PLATFORMS.MEITUAN:
          return mtShopLink || '';

        case PLATFORMS.DAZHONGDIANPING: {
          // 优先使用 dzShopLink
          // if (dzShopLink) return dzShopLink;

          if (dzShopConfig) {
            const shopId = this.extractIdFromUrl(dzShopConfig);
            return shopId ? `dianping://shopinfo?shopuuid=${shopId}` : '';
          }

          return '';
        }

        case PLATFORMS.XIAOHONGSHU:
          return item.deeplink || '';

        default:
          return '';
      }
    },

    fetchThemeText(item) {
      this.shareText = "";
      this.sseBuffer = "";

      const data = {
        shopId: item.shopId,
        qrCodeId: item.qrCodeId,
        themeId: item.id
      };

      this.$POSTSTREAM('/customer/evaluation/copy/generateCopy', data, {
        onMessage: (chunk) => this.handleStreamChunk(chunk),
        onFinish: () => console.log('最终完整文本:', this.shareText)
      });
    },

    handleStreamChunk(chunk) {
      this.sseBuffer += chunk
      while (true) {
        const index = this.sseBuffer.indexOf('data:')
        if (index === -1) break

        const nextIndex = this.sseBuffer.indexOf('data:', index + 5)
        let content

        if (nextIndex !== -1) {
          content = this.sseBuffer.slice(index + 5, nextIndex)
          this.sseBuffer = this.sseBuffer.slice(nextIndex)
        } else {
          break
        }

        content = content.trim()

        if (content === '[DONE]') {
          return
        }
        if (content) {
          this.shareText += content
        }
      }
    },

    validateShareContent() {
      if (!this.shareText) {
        this.$message.warning("没有可分享的文案");
        return false;
      }
      return true;
    },
    isHuaweiBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      return (
          ua.includes("huawei") ||
          ua.includes("honor") ||
          ua.includes("hwbrowser") ||
          ua.includes("hmos") ||
          ua.includes("harmony")
      );
    },


    syncExecCopy(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;

      Object.assign(textarea.style, {
        position: "fixed",
        top: "-9999px",
        left: "-9999px",
        opacity: "0"
      });

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, text.length);

      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      return ok;
    },

    /**
     * 统一入口：自动选择 clipboard API 或同步 copy
     */
    copyTextToClipboard() {
      const text = this.shareText;

      return new Promise((resolve, reject) => {
        if (this.isHuaweiBrowser()) {
          const ok = this.syncExecCopy(text);
          ok ? resolve() : reject(new Error("复制失败"));
          return;
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text)
              .then(() => resolve(true))
              .catch(() => {
                // 自动 fallback
                const ok = this.syncExecCopy(text);
                ok ? resolve() : reject(new Error("复制失败"));
              });
          return;
        }

        const ok = this.syncExecCopy(text);
        ok ? resolve() : reject(new Error("复制失败"));
      });
    },

    handleDeepLink() {
      const deeplink = this.shareData.deeplink;
      if (!deeplink || !this.canDeepLink) return;

      const { model = "" } = this.deviceInfo || {};
      const directJumpModels = ["iPhone", "OpenHarmony"];

      setTimeout(() => {
        if (directJumpModels.includes(model)) {
          window.location.href = deeplink;
        } else {
          const a = document.createElement('a');
          a.href = deeplink;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }, 1500);
    },


    onShare() {
      if (!this.validateShareContent()) return;

      this.copyTextToClipboard()
          .then(() => {
            this.$message.success("文案已复制");
            this.handleDeepLink();
          })
          .catch(() => {
            this.$message.warning("复制失败，请手动复制");
          });
    },
    checkBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      const parser = new UAParser();
      const result = parser.getResult();

      const isAlipay = ua.includes("alipayclient");
      const isAlipayMini = ua.includes("miniprogram");
      const isWeChat = ua.includes("micromessenger");
      const isQQ = ua.includes(" qq/");
      const isDingTalk = ua.includes("dingtalk");

      this.canDeepLink = !(isAlipay || isAlipayMini || isWeChat || isQQ || isDingTalk);

      this.deviceInfo = {
        os: result.os.name,
        brand: result.device.vendor,
        model: result.device.model
      };
    },

    extractIdFromUrl(url) {
      try {
        const path = new URL(url).pathname;
        const match = path.match(/[^/]+(?=\/?$)/);
        return match ? match[0] : null;
      } catch (e) {
        console.error('Invalid URL:', url, e);
        return null;
      }
    },

    handleApiError(error) {
      console.error('API Error:', error);
      this.$messageBox.alert(error.msg || '请求失败', '提示', {
        confirmButtonText: '确定',
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.share-page {
  background: #f7f8fa;
  position: fixed;
  width: 100%;
  height: 100dvh;
  min-height: 100vh;
  top: 0;
  box-sizing: border-box;
}

.scrollable-content {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.card-box, .content-box {
  background: #fff;
  border-radius: 10px;
  padding: 14px;
  margin: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.image-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666;
}

.image-header .left {
  font-weight: bold;
  font-size: 15px;
  color: #333;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.image-grid .img-item {
  width: 100%;
  height: 100px;
  background: #f5f5f5;
  border-radius: 6px;
  overflow: hidden;
}

.image-grid .img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.content-box {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.content-header {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #ccc;
}

.content-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
}

.content-box .desc {
  font-size: 14px;
  line-height: 1.6;
  color: #555;
}

.bottom-action {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}

.share-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
